import {
  CLEAR_API_KEY_STATE,
  CREATE_API_KEY_FAILURE,
  CREATE_API_KEY_REQUEST,
  CREATE_API_KEY_RESPONSE,
  DELETE_API_KEY_FAILURE,
  DELETE_API_KEY_REQUEST,
  DELETE_API_KEY_RESPONSE,
  GET_API_KEY_FAILURE,
  GET_API_KEY_REQUEST,
  GET_API_KEY_RESPONSE,
  UPDATE_API_KEY_FAILURE,
  UPDATE_API_KEY_REQUEST,
  UPDATE_API_KEY_RESPONSE
} from "./actions";

const apiKeysInitialState = {
  isLoading: false,
  error: null,
  data: {
    items: [],
    toDelete: [],
    toUpdate: []
  },
  newApiKey: {},
  totalCount: 0,
  selectedApiKey: null
}

export default (state = apiKeysInitialState, action) => {
  switch (action.type) {
    case GET_API_KEY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true
      }
    case GET_API_KEY_RESPONSE:
      let apiKeyObject = {
        items: action.resetCache ? (action.data || []) : state.data.items.concat(action.data),
        toDelete: [],
        toUpdate: []
      }
      return {
        ...state,
        totalCount: action.totalCount,
        data: apiKeyObject,
        error: null,
        isLoading: false
      }
    case GET_API_KEY_FAILURE:
      return {
        ...state,
        error: action.error || "An error occurred",
        isLoading: false
      }

    case CREATE_API_KEY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true
      }
    case CREATE_API_KEY_RESPONSE:
      return {
        ...state,
        newApiKey: action.data,
        error: null,
        isLoading: false
      }
    case CREATE_API_KEY_FAILURE:
      return {
        ...state,
        error: action.error || "An error occurred",
        isLoading: false
      }
    case DELETE_API_KEY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true
      }
    case DELETE_API_KEY_RESPONSE:
      return {
        ...state,
        error: null,
        isLoading: false
      }
    case DELETE_API_KEY_FAILURE:
      return {
        ...state,
        error: action.error || "An error occurred",
        isLoading: false
      }

    case UPDATE_API_KEY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true
      }
    case UPDATE_API_KEY_RESPONSE:
      return {
        ...state,
        error: null,
        isLoading: false
      }
    case UPDATE_API_KEY_FAILURE:
      return {
        ...state,
        error: action.error || "An error occurred",
        isLoading: false
      }

    case CLEAR_API_KEY_STATE:
      return {
        ...state,
        newApiKey: apiKeysInitialState.newApiKey,
      }

    default:
      return state
  }
}